var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-seo-frame-advisor-faq" },
    [
      _c("div", { staticClass: "rb-seo-frame-advisor-faq__title" }, [
        _vm._v(_vm._s(_vm.$t("seo_frame_advisor_faq.title"))),
      ]),
      _vm._v(" "),
      _c(
        "rb-faq-module",
        {
          staticClass: "rb-seo-frame-advisor-faq__accordion-wrapper",
          scopedSlots: _vm._u([
            {
              key: "cta_block",
              fn: function () {
                return [
                  _c(
                    "a",
                    {
                      staticClass: "rb-btn rb-btn--white",
                      attrs: { href: _vm.faqLink },
                    },
                    [_vm._v(_vm._s(_vm.$t("seo_frame_advisor_faq.cta")))]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        _vm._l(_vm.mainEntityLength, function (index) {
          return _c(
            "rb-faq-accordion",
            {
              key: index,
              scopedSlots: _vm._u(
                [
                  {
                    key: "accordion_title",
                    fn: function () {
                      return [
                        _vm._v(" " + _vm._s(_vm.questions[index - 1]) + " "),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            },
            [
              _vm._v(" "),
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.answersAsHTML[index - 1]) },
              }),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }